// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { env } from '@/lib/env';
import { captureError } from '@/lib/sentry';

const SUPABASE_URL = env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
  global: {
    fetch: async (url, options) => {
      try {
        const response = await fetch(url, options);
        
        // Log failed requests to Sentry
        if (!response.ok && response.status >= 500) {
          captureError(new Error(`Supabase API error: ${response.status}`), {
            url: url.toString(),
            status: response.status,
            method: options?.method,
          });
        }
        
        return response;
      } catch (error) {
        // Network errors
        captureError(
          error instanceof Error ? error : new Error('Supabase fetch failed'),
          {
            url: url.toString(),
            method: options?.method,
            networkError: true,
          }
        );
        throw error;
      }
    },
  },
});